/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-09 10:20:05
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-03 10:52:45
 * @FilePath: \合联\oms\src\api\analysis\gccOrderStatistics.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/report/gcc/'

export const apis = buildApi({
  get: [name + 'order', '/common/province&getProvince', name + 'tracker', name + 'pickup', name + 'time', name + 'rate', name + 'delivery_first', name + 'delivery_new', name + 'country', name + 'province', name + 'city', name + 'status'],
  post: []
})